import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { ApiJSONService, DomainBrandService, SeoService } from '@services/index';
import { ProductCatalog, ProductInterface } from '@interfaces/index';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import * as ownActions from '@redux/actions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-products-detail',
  templateUrl: './products-detail.component.html',
  styleUrls: ['./products-detail.component.scss'],
})
export class ProductsDetailComponent implements OnInit, OnDestroy {
  data: ProductInterface;
  dataBrands: any = [];
  dataFeatures: any = [];
  dataCatalog: any = [];
  type: any;
  private _paramsSub?: Subscription;

  constructor(
    private _apiJSONService: ApiJSONService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _store: Store<AppState>,
    public brand: DomainBrandService,
    private _seo: SeoService
  ) {}

  /**
   * -------------------------------------------------------
   * @summary ngOnInit
   * @description  Inicializa funciones al cargar el
   * -------------------------------------------------------
   */
  ngOnInit(): void {
    this.getData();
  }

  /**
   * -------------------------------------------------------
   * @summary getData
   * @description Retorna la data page - products
   * -------------------------------------------------------
   */
  async getData() {
    await this._apiJSONService
      .getJSONProducts('../assets/data/products.json')
      .subscribe(
        (resp) => {
          this.data = resp;
          this.dataFeatures = this.data.features;
          this.getTypeProduct(this.data);
          this._store.dispatch(ownActions.setLoading({ loading: false }));
        },
        (error) => {
          this._store.dispatch(ownActions.setLoading({ loading: true }));
          console.log(`error`, error);
        },
        () => {}
      );
  }

  /**
   * -------------------------------------------------------
   * @summary getIdProduct
   * @description  Obtiene el product por el ID, y la posicion del arreglo
   * @param {any} array Arreglo de productos
   * -------------------------------------------------------
   */
  getIdProduct(array: any, id: number) {
    return array.products.find((opt) => opt.id === id);
  }

  /**
   * -------------------------------------------------------
   * @summary getTypeProduct
   * @description  Obtiene el nombre del producto desde la url y asigna posicion de arreglo en data
   * @param {any} array Arreglo de productos
   * -------------------------------------------------------
   */
  getTypeProduct(array: any) {
    this._paramsSub = this._activatedRoute.params.subscribe((params) => {
      this.type = params['detail'];
      switch (this.type) {
        case 'treatment-fluids':
          this.data = this.getIdProduct(array, 1);
          break;
        case 'wire-lighting':
          this.data = this.getIdProduct(array, 2);
          break;
        case 'heavy-machinery':
          this.data = this.getIdProduct(array, 3);
          break;
        case 'generation-power':
          this.data = this.getIdProduct(array, 4);
          break;
        case 'tools-equipment':
          this.data = this.getIdProduct(array, 5);
          break;
        case 'petroleum-gas':
          this.data = this.getIdProduct(array, 6);
          break;
        default:
          this._router.navigateByUrl('/not-found');
          return;
      }
      const product = this.data as unknown as ProductCatalog;
      if (product?.title) {
        const desc = product.description
          ? ProductsDetailComponent.truncateMeta(product.description, 300)
          : undefined;
        this._seo.setPageMeta({
          title: `${product.title} | ${this.brand.documentTitle}`,
          description: desc,
          imageUrl: SeoService.absoluteAssetUrl(product.icon ?? ''),
        });
      }
    });
  }

  private static truncateMeta(text: string, max: number): string {
    const t = text.trim();
    if (t.length <= max) {
      return t;
    }
    return `${t.slice(0, max - 1).trim()}…`;
  }

  ngOnDestroy(): void {
    this._paramsSub?.unsubscribe();
  }

}
